import React from 'react';
import Icon, { IconType } from '../../icons/Icon';

interface MultiTextInputItem {
  text: string;
  onRemove: (event: React.MouseEvent<HTMLElement>) => void;
  /** Expects an inline element */
  leading?: React.ReactNode;
}

export default function MultiTextInputItem({ text, onRemove, leading }: MultiTextInputItem) {
  return (
    <div className='flex h-fit w-fit max-w-full items-center gap-1 overflow-clip rounded-1 bg-primary-200 stroke-black px-1 py-2 text-sm font-medium text-black'>
      {leading && leading}
      <span className='flex-grow overflow-hidden text-ellipsis' title={text}>
        {text}
      </span>
      <Icon type={IconType.xClose} size={'size-4'} stroke={'stroke-gray-500'} onClick={onRemove} />
    </div>
  );
}
